const companyType = [
    { label: 'SIRE', value: 'SIRE' },
    { label: 'BIRE', value: 'BIRE' },
    { label: 'Vetting', value: 'Vetting' },
];

export default companyType;
